<div class="container" *ngIf="!isLoading">
    <div class="header">
        {{
            (editMode ? 'editor.library.category.dialog.edit.title' : 'editor.library.category.dialog.create.title')
                | translate
        }}
    </div>
    <div class="main">
        <app-input-select-with-error
            class="wider-input"
            [initialValue]="selectedLibrary?.name || ''"
            [legend]="'editor.library.legend'"
            [propertyName]="LIBRARY_INPUT_NAME"
            [optionsArray]="libraryNameList"
            [maxLength]="50"
            [placeholder]="'editor.library.select-library.label'"
            (onInputUpdated)="selectLibrary($event)"
            [otherValidationErrors]="libraryError"></app-input-select-with-error>
        <app-channel-text-input
            class="library-category-name"
            [name]="NAME_INPUT_NAME"
            [value]="libraryCategoryName"
            [label]="'editor.library.dialog.name.legend'"
            [placeholder]="'editor.library.dialog.name.placeholder'"
            (onInputChange)="changeLibraryCategoryName($event.value)"
            (onFocusChange)="changeLibraryCategoryName($event.value)"
            [maxLength]="NAME_MAX_LEN"
            [inputError]="validationErrors?.name"></app-channel-text-input>
    </div>
    <div class="footer">
        <div class="button-container">
            <button class="text-button" (click)="close()">
                {{ 'dlg.cancel' | translate }}
            </button>
            <app-button
                [disable]="disabledCreateButton()"
                [text]="
                    editMode
                        ? 'editor.library.category.dialog.edit.button'
                        : 'editor.library.category.dialog.create.button'
                "
                customFontFamily="NotoSans-SemiBold"
                size="small"
                customFontSize="14px"
                (onClick)="save()"></app-button>
        </div>
    </div>
</div>

<app-loading-spinner
    *ngIf="isLoading"
    class="spinner-component"
    [custom]="true"
    size="80"
    strokeWidth="3"></app-loading-spinner>
